import { render } from "./MaterialsSelect.vue?vue&type=template&id=00278b1a&lang=pug"
import script from "./MaterialsSelect.vue?vue&type=script&lang=ts"
export * from "./MaterialsSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script